import { FlexBox } from '@vp/swan';
import { useLineItemActions } from '../contexts/LineItemActionsContext';
import { BUY_IT_AGAIN_PAGE_NAME } from '../../constants/sourcePage';
import { ItemBuyNowButton } from '../shared/ItemBuyNowButton';
import { ItemAddToCartButton } from '../shared/reorder/ItemAddToCartButton';

export const BuyItAgainLineItemActions = () => {
  const { buyNowActionEnabled, reorderActionEnabled } = useLineItemActions();

  if (!buyNowActionEnabled && !reorderActionEnabled) {
    return null;
  }

  return (
    <FlexBox flexWrap="initial" flexDirection="column" gap="between-actions">
      {buyNowActionEnabled && (
        <ItemBuyNowButton pageName={BUY_IT_AGAIN_PAGE_NAME} />
      )}
      {reorderActionEnabled && (
        <ItemAddToCartButton
          buttonSkin={buyNowActionEnabled ? 'secondary' : 'primary'}
          buttonWidth="full-width"
        />
      )}
    </FlexBox>
  );
};
